import { FormBuilderType, FormBuilderValidator } from "@grassrootly/rn-core";

export const loginForm: FormBuilderType<LoginDTO> = {
  email: {
    type: "input",
    name: "email",
    label: "Email",
    defaultValue: "",
    validators: [FormBuilderValidator.required(), FormBuilderValidator.email()],
    required: true,
    props: {
      keyboardType: "email-address",
    },
  },
  password: {
    type: "password",
    name: "password",
    label: "Password",
    defaultValue: "",
    validators: [FormBuilderValidator.required()],
    required: true,
    props: {
      keyboardType: "visible-password",
    },
  },
};

export interface LoginDTO {
  email: string;
  password: string;
}
